module.exports = __webpack_public_path__ + "img/photo-0037.71ac1e28.jpg";